import { type AdminApproval, type AdminApprovalRoleRef, AdminApprovalStatus, type Role } from '@column/api';

import { DashboardUserRedacted } from '~/repositories';
import { getRoleLabel, precannedRolesByName } from '~/repositories/RoleRepository';

export const approvalStatusLabels: Record<AdminApprovalStatus, string> = {
  [AdminApprovalStatus.PENDING]: 'Pending',
  [AdminApprovalStatus.APPROVED]: 'Approved',
  [AdminApprovalStatus.REJECTED]: 'Rejected',
  [AdminApprovalStatus.EXPIRED]: 'Expired',
};

export const getEffectiveStatus = (approval: AdminApproval): AdminApprovalStatus =>
  approval.status === AdminApprovalStatus.PENDING && new Date(approval.expires_at) <= new Date()
    ? AdminApprovalStatus.EXPIRED
    : approval.status;

export const getUserName = (users: DashboardUserRedacted[], userId?: string) => {
  if (!userId) return 'Unknown user';
  const user = users.find((u) => u.id === userId);
  return user ? `${user.firstName} ${user.lastName}` : userId;
};

export const getRoleName = (roles: KeysCamelCaseDeep<Role>[], roleId?: string, precannedName?: string) => {
  if (precannedName) return getRoleLabel(precannedName);
  if (!roleId) return 'No role';
  const role = roles.find((r) => r.id === roleId);
  return role ? getRoleLabel(role.name) : roleId;
};

export const getRefName = (roles: KeysCamelCaseDeep<Role>[], ref: AdminApprovalRoleRef) =>
  getRoleName(roles, ref.custom_role_id, ref.precanned_role_name);

const getRefRoleId = (ref: AdminApprovalRoleRef) =>
  ref.custom_role_id ?? (ref.precanned_role_name ? precannedRolesByName[ref.precanned_role_name]?.id : undefined);

export const findRole = (roles: KeysCamelCaseDeep<Role>[], ref: AdminApprovalRoleRef) => {
  const roleId = getRefRoleId(ref);
  return roleId ? roles.find((role) => role.id === roleId) : undefined;
};
